import { render, staticRenderFns } from "./HomeWhyUs.vue?vue&type=template&id=16f0f736&scoped=true&"
import script from "./HomeWhyUs.vue?vue&type=script&lang=js&"
export * from "./HomeWhyUs.vue?vue&type=script&lang=js&"
import style0 from "./HomeWhyUs.vue?vue&type=style&index=0&id=16f0f736&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f0f736",
  null
  
)

export default component.exports